module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "ملحوظة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ملحوظة")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يعترِض الإخوة المسيحيُّون على تسمية الحملات بوَصف \"الصليبيَّة\" حيث إنَّ هذا يعني المسيحيَّة؛ ولا يفرّق بين كَون الصليبيِّين مسيحيين غربيين \"فرنجة\"، أو شرقيين عرب.. الشرقيون حاربوا على مرِّ الزَّمان للدفاع عن الأرض المقدَّسة، وعن أوطانهم بجانب المسلمين، فبالتالي يجب التفريق بينهم والغُزاة مِن الغرب، وهم يُفضِّلون لفظ الفرنجة بدل من الصليبيِّين، أنا أشارِكهم في هذا الرأي والإحساس، لكن عندما يُذكر التاريخ يجب أن يقيَّد كما كان، وتبقى المسمِّيات كما كانت، حتى لو كانت خاطئة.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("(انظر خطبة الجمعة الأولى بالقدس).")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 75
// module chunks = 0